import { FormlyFieldConfig } from '@ngx-formly/core';

export interface FormFieldsConfig {
  inputs: FormlyFieldConfig[];
  description?: string;
  permissions: string[];
  title: string;
  callbacks?: any;
}
